import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";

import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
 
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";   

import { MatrizTarifaList } from "./list/list";
import { MatrizTarifaEdit } from "./edit/edit";

export class MatrizTarifaCatalogo extends React.Component {
    render() {
        return (
            <div>
                <Route exact path="/catalogos/MatrizTarifa"  component={MatrizTarifaList} />
                <Route path="/catalogos/MatrizTarifa/:id"  component={MatrizTarifaEdit} />
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/matricestarifa/index.tsx